import AppDirectory from 'components/pie/app_directory/index';

// When rendering the AppDirectory directly, there is an error when the AppDirectory
// has a useState call. Wrapping the component + importing React here seems to fix the issue.
// This may be related to an issue that would be fixed by upgrading
// the rails_on_react gem to v12 (https://github.com/shakacode/react_on_rails/blob/master/CHANGELOG.md#major-improvements),
// where it lists "React Hooks Support for top level components" as a change.
const AppDirectoryWrapper = props => {
  return <AppDirectory {...props} />;
};

export default AppDirectoryWrapper;
